module.exports = __webpack_public_path__ + "img/orange_089.8108854c.png";